<template>
	<router-view />
</template>

<script setup>
// No se necesita lógica aquí, el enrutador controla la navegación
</script>
